import { Select, Tooltip } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowDown, faArrowUp, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../components/Button';
import { useFeaturedProductPicker } from './useFeaturedProductPicker';
import classes from './digital-menu-management.module.scss';

type Props = { tenantId: string; ids: number[]; disabled: boolean; onChange: (ids: number[]) => void };
export function FeaturedProductPicker({ tenantId, ids, disabled, onChange }: Props) {
  const state = useFeaturedProductPicker(tenantId);
  const move = (index: number, offset: number) => {
    const next = [...ids];
    [next[index], next[index + offset]] = [next[index + offset], next[index]];
    onChange(next);
  };
  return <section className={classes.featuredSection} aria-label="הכי מוזמנים">
    <h3>הכי מוזמנים <span>{ids.length}/6</span></h3>
    <ol className={classes.featuredList}>{ids.map((id, index) => {
      const name = state.known[id]?.name ?? `מוצר #${id}`;
      return <li key={id}>
        <span className={classes.featuredName}>{name}</span>
        <div className={classes.featuredActions}>
          <Tooltip label="הזזה למעלה"><span><Button variant="icon" aria-label={`הזזת ${name} למעלה`} disabled={disabled || index === 0} onClick={() => move(index, -1)}><FontAwesomeIcon icon={faArrowUp as IconProp} /></Button></span></Tooltip>
          <Tooltip label="הזזה למטה"><span><Button variant="icon" aria-label={`הזזת ${name} למטה`} disabled={disabled || index === ids.length - 1} onClick={() => move(index, 1)}><FontAwesomeIcon icon={faArrowDown as IconProp} /></Button></span></Tooltip>
          <Tooltip label="הסרה"><span><Button variant="icon" aria-label={`הסרת ${name}`} disabled={disabled} onClick={() => onChange(ids.filter((selected) => selected !== id))}><FontAwesomeIcon icon={faTrashCan as IconProp} /></Button></span></Tooltip>
        </div>
      </li>;
    })}</ol>
    <Select label="הוספת מוצר להכי מוזמנים" placeholder="חיפוש מוצר" searchable clearable value={null}
      disabled={disabled || ids.length >= 6} searchValue={state.search} onSearchChange={state.setSearch}
      filter={({ options }) => options} nothingFoundMessage={state.loading ? 'טוען מוצרים' : 'לא נמצאו מוצרים'}
      data={state.products.filter((product) => !ids.includes(product.id)).map((product) => ({ value: String(product.id), label: product.name }))}
      onChange={(value) => { if (value && ids.length < 6 && !ids.includes(Number(value))) { onChange([...ids, Number(value)]); state.setSearch(''); } }} />
    {state.error && <div role="alert">{state.error}<Button variant="icon" onClick={state.retry}>נסו שוב</Button></div>}
    {state.hasMore && ids.length < 6 && <Button variant="icon" disabled={disabled || state.loading} loading={state.loading} onClick={state.loadMore}>מוצרים נוספים</Button>}
  </section>;
}